module.exports = __webpack_public_path__ + "static/img/animales_06.810b3440.jpg";